/**
 * Custom Signature Animation
 * 
 * Gerencia a animação e visibilidade do seletor de frequência
 * quando o usuário seleciona entre "Assinatura" e "Compra Única"
 * 
 * Funciona tanto na página de produto quanto no carrinho lateral
 */

(function() {
  'use strict';

  /**
   * Sincroniza a seleção do header com o primeiro input de frequência
   * Quando o header está selecionado, garante que o primeiro input (30 Dias) também esteja
   */
  function syncHeaderWithFirstFrequency() {
    const signatureHeaders = document.querySelectorAll('[data-plan-header="signature"]');
    
    signatureHeaders.forEach(header => {
      const headerInput = header.querySelector('.plan-header-input');
      const frequencySelector = header.closest('.subscription-section').querySelector('[data-frequency-selector]');
      
      if (!headerInput || !frequencySelector) return;
      
      // Função para sincronizar header com frequência
      function syncHeader() {
        const firstFrequencyInput = frequencySelector.querySelector('input[type="radio"]');
        
        // Se o primeiro input de frequência está checked, marca o header também
        if (firstFrequencyInput && firstFrequencyInput.checked) {
          headerInput.checked = true;
        }
      }
      
      // Sincroniza estado inicial
      syncHeader();
      
      // Quando o input do header é clicado/selecionado
      headerInput.addEventListener('change', function() {
        if (this.checked) {
          // Verifica se ALGUM input de frequência já está selecionado
          const checkedFrequencyInput = frequencySelector.querySelector('input[type="radio"]:checked');

          // Só seleciona 30 dias se NENHUM estiver selecionado
          if (!checkedFrequencyInput) {
            const firstFrequencyInput = frequencySelector.querySelector('input[type="radio"]');
            if (firstFrequencyInput) {
              firstFrequencyInput.checked = true;
              firstFrequencyInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      });

      // Quando qualquer input de frequência muda, sincroniza o header
      frequencySelector.addEventListener('change', function(e) {
        if (e.target.matches('input[type="radio"]')) {
          syncHeader();
        }
      });
    });
  }

  /**
   * Atualiza a visibilidade do seletor de frequência
   * baseado no plano selecionado
   */
  function updateFrequencySelectorVisibility() {
    // Busca todos os containers de subscription-section (pode haver múltiplos: página + carrinho)
    const subscriptionSections = document.querySelectorAll('.subscription-section');
    
    subscriptionSections.forEach(section => {
      // Busca o header de assinatura dentro desta seção
      const signatureHeader = section.querySelector('[data-plan-header="signature"]');
      // Busca o seletor de frequência dentro desta seção
      const frequencySelector = section.querySelector('[data-frequency-selector]');
      
      if (!signatureHeader || !frequencySelector) return;
      
      // Verifica se algum input dentro do header de assinatura está selecionado
      const signatureInput = signatureHeader.querySelector('input[type="radio"]:checked');
      const isSignatureSelected = signatureInput && signatureInput.closest('[data-plan-header="signature"]') !== null;
      
      if (isSignatureSelected) {
        // Remove a classe 'hide' para mostrar o seletor de frequência
        frequencySelector.classList.remove('hide');
      } else {
        // Adiciona a classe 'hide' para esconder o seletor de frequência
        frequencySelector.classList.add('hide');
      }
    });
  }

  /**
   * Seleciona automaticamente a assinatura 30 dias quando o modal opener é clicado
   */
  function handleModalOpenerClick() {
    // Usa event delegation para capturar cliques em qualquer elite-benefits-opener
    document.addEventListener('click', function(e) {
      const opener = e.target.closest('.elite-benefits-opener');
      if (!opener) return;

      // Encontra o header de assinatura mais próximo (dentro do mesmo subscription-section)
      const subscriptionSection = opener.closest('.subscription-section');
      if (!subscriptionSection) return;
      
      const signatureHeader = subscriptionSection.querySelector('[data-plan-header="signature"]');
      if (!signatureHeader) return;
      
      const headerInput = signatureHeader.querySelector('.plan-header-input');
      if (!headerInput) return;
      
      // Desmarca o input de "Compra Única" se estiver selecionado
      const oneTimeHeader = subscriptionSection.querySelector('[data-plan-header="one-time"]');
      if (oneTimeHeader) {
        const oneTimeInputs = oneTimeHeader.querySelectorAll('input[type="radio"]');
        oneTimeInputs.forEach(input => {
          if (input.checked) {
            input.checked = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
      
      // SALVA a frequência atual ANTES de qualquer dispatchEvent
      const frequencySelectorForSave = subscriptionSection.querySelector('[data-frequency-selector]');
      const savedFrequencyInput = frequencySelectorForSave?.querySelector('input[type="radio"]:checked');
      const savedFrequencyValue = savedFrequencyInput?.value || null;

      // Seleciona o input do header de assinatura
      headerInput.checked = true;
      
      // Dispara eventos para atualizar a UI e localStorage
      headerInput.dispatchEvent(new Event('change', { bubbles: true }));
      headerInput.dispatchEvent(new Event('input', { bubbles: true }));
      
      // RESTAURA a frequência salva (se havia uma selecionada)
      if (savedFrequencyValue && frequencySelectorForSave) {
        const inputToRestore = frequencySelectorForSave.querySelector(`input[type="radio"][value="${savedFrequencyValue}"]`);
        if (inputToRestore && !inputToRestore.checked) {
          inputToRestore.checked = true;
          inputToRestore.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      
      // Força atualização do localStorage e UI
      // Aguarda um pequeno delay para garantir que os eventos sejam processados
      setTimeout(function() {
        // SALVA a frequência atual antes dos eventos do setTimeout
        const freqSelectorTimeout = subscriptionSection.querySelector('[data-frequency-selector]');
        const savedFreqTimeout = freqSelectorTimeout?.querySelector('input[type="radio"]:checked');
        const savedValueTimeout = savedFreqTimeout?.value || null;

        // Dispara eventos para garantir que updatePricesAndButton seja chamado
        const newVariantsSection = subscriptionSection.closest('.new-variants');
        if (newVariantsSection) {
          // Dispara click no header para acionar o listener que chama updatePricesAndButton
          // Isso garante que o localStorage seja atualizado com o choiceValue correto
          signatureHeader.dispatchEvent(new Event('click', { bubbles: true }));
          
          // Também dispara change no quantityFieldset para garantir atualização completa
          const quantityFieldset = newVariantsSection.querySelector('.product-form__input');
          if (quantityFieldset) {
            quantityFieldset.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        
        // RESTAURA a frequência após os eventos do setTimeout
        if (savedValueTimeout && freqSelectorTimeout) {
          const inputToRestoreTimeout = freqSelectorTimeout.querySelector(`input[type="radio"][value="${savedValueTimeout}"]`);
          if (inputToRestoreTimeout && !inputToRestoreTimeout.checked) {
            inputToRestoreTimeout.checked = true;
            inputToRestoreTimeout.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }, 100);
    });
  }

  /**
   * Inicializa os event listeners
   */
  function initSignatureAnimation() {
    // Sincroniza header com primeiro input de frequência
    syncHeaderWithFirstFrequency();
    
    // Adiciona handler para cliques no modal opener
    handleModalOpenerClick();
    
    // Usa event delegation para capturar mudanças em qualquer input de plan-header
    // Funciona mesmo quando elementos são adicionados dinamicamente (ex: carrinho lateral)
    document.addEventListener('change', function(e) {
      const target = e.target;
      
      // Verifica se o input que mudou está dentro de um plan-header ou é um input de frequência
      if (target.matches('[data-plan-header] input[type="radio"], [data-plan-header="signature"] input[type="radio"], [data-plan-header="one-time"] input[type="radio"], [data-frequency-selector] input[type="radio"]')) {
        updateFrequencySelectorVisibility();
      }
    });
    
    // Atualiza a visibilidade inicial ao carregar a página
    updateFrequencySelectorVisibility();
  }

  /**
   * Re-inicializa quando o cart drawer é aberto
   * (para garantir que a animação funcione no carrinho lateral)
   */
  function handleCartDrawerOpen() {
    // Aguarda um pequeno delay para garantir que o DOM do carrinho foi renderizado
    setTimeout(function() {
      syncHeaderWithFirstFrequency();
      updateFrequencySelectorVisibility();
    }, 100);
  }

  // Inicializa quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSignatureAnimation);
  } else {
    initSignatureAnimation();
  }

  // Observa quando o cart drawer é aberto (se o evento existir)
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    // Usa MutationObserver para detectar quando o drawer é aberto
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            handleCartDrawerOpen();
          }
        }
      });
    });
    
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Expõe a função globalmente para permitir atualização manual se necessário
  window.updateSignatureFrequencyVisibility = updateFrequencySelectorVisibility;
})();

